export default "__VITE_ASSET__da0175ec__"